module.exports = __webpack_public_path__ + "build/desktop/a/img/home.94d8ed6511184ad803112d755c2f2e35.png";